module.exports = __webpack_public_path__ + "img/turnOff-red-icon.3ed23f98.svg";